import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RouterModule } from '@angular/router';
import { ComponentsModule } from '../../components/components.module';
import { MenuPopoverComponentModule } from '../menu-popover/menu-popover.module';
import { DesktopHeaderComponent } from './desktop-header.component';

@NgModule({
  imports: [
    CommonModule, FormsModule, IonicModule,
    RouterModule,
    MenuPopoverComponentModule,
    ComponentsModule

  ],
  declarations: [DesktopHeaderComponent],
  exports: [DesktopHeaderComponent]
})
export class DesktopHeaderComponentModule { }
